import { render, staticRenderFns } from "./Launcher.vue?vue&type=template&id=d15bd490&scoped=true"
import script from "./Launcher.vue?vue&type=script&lang=ts&setup=true"
export * from "./Launcher.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15bd490",
  null
  
)

export default component.exports